import { DemoRoundEngineService, DemoAction } from "./demo-round-engine.service";
import { DemoWalletService } from "./demo-wallet.service";

export class DemoGameService {
  readonly wallet = new DemoWalletService();
  readonly roundEngine = new DemoRoundEngineService(this.wallet);

  start(): void {
    this.roundEngine.start();
  }

  stop(): void {
    this.roundEngine.stop();
  }

  send(message: DemoAction | DemoAction[]): void {
    this.roundEngine.handleActions(message);
  }

  resetBalance(): void {
    this.wallet.reset();
  }
}

export const demoGameService = new DemoGameService();
